import { NavLink } from 'react-router-dom';
import { cn } from '@mlm/ui/lib/cn';
import { useAuthStore } from '../lib/auth-store';

/**
 * Sub-navigation for the LEARN side: what the member already has, and the
 * catalogue. The Shop is the MLM side and has its own sub-navigation. A visitor
 * who is not signed in has no courses of their own, so they see Browse only.
 */
const ITEMS = [
  { to: '/learn', label: 'My courses', end: true },
  { to: '/learn/browse', label: 'Browse', end: false },
] as const;

export function LearnNav() {
  const signedIn = !!useAuthStore((s) => s.token);
  const items = signedIn ? ITEMS : ITEMS.filter((item) => item.to !== '/learn');
  return (
    <nav aria-label="Learn" className="border-b border-border px-5">
      <ul className="flex gap-6">
        {items.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                cn(
                  'inline-flex min-h-11 items-center border-b-2 font-mono text-[0.62rem] uppercase tracking-[0.14em] transition-colors',
                  isActive
                    ? 'border-verde text-ink'
                    : 'border-transparent text-sage-deep hover:text-ink',
                )
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
